import configApp from '@/config'
import Vue from 'vue'

let utils = new Vue({
  data () {
    return {
      academyDomain: configApp.academyDomain,
      apiKeyTinyMce: configApp.apiKeyTinyMce,
      appDomain: configApp.appDomain,
      generatorPdfDomain: configApp.pdfGeneratorDomain,
      marketPlaceDomain: configApp.marketPlaceDomain,
      showAsideNavigationMenu: true,
      universityDomain: configApp.universityDomain
    }
  },

  methods: {
    addDaysToDate (date, days) {
      var dat = new Date(date)
      dat.setDate(dat.getDate() + days)
      return `${dat.getUTCFullYear()}-${dat.getUTCMonth() + 1}-${dat.getUTCDate()}`
    },

    bottomPage () {
      window.scrollTo(0, document.body.scrollHeight)
    },

    bottomVisible () {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      return bottomOfPage || pageHeight < visible
    },

    // Creditos de Inteligencia Artificial: siempre el numero real con punto de miles ("10.000").
    // Nunca "ilimitado": un 0 es un 0. No usa toLocaleString porque 'es' no agrupa los numeros de
    // 4 cifras y mostraria "5000" al lado de "10.000"
    formatCredits (value) {
      const numero = Math.trunc(Number(value) || 0)
      const digitos = String(Math.abs(numero)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')

      return numero < 0 ? `-${digitos}` : digitos
    },

    formatISODateTime (date, isDateTime = false) {
      let fecha = date.split('T')
      return isDateTime ? `${fecha[0]} ${(fecha[1]).split('-')[0]}` : fecha[0]
    },

    frequency (frecuencia) {
      switch (frecuencia) {
        case 1: return 'days'
        case 2: return 'weeks'
        case 3: return 'months'
        case 4: return 'years'
      }
    },

    getAcademyDomain () {
      return this.academyDomain
    },

    getAppDomain () {
      return this.appDomain
    },

    getCssVariable (variable) {
      return getComputedStyle(document.documentElement).getPropertyValue(variable)
    },

    getPaymentFrequency (cuotas, frecuencia, intervalo) {
      return cuotas === 1
        ? '1 pago'
        : cuotas === 0
          ? `1 pago cada 1 ${this.$filters.getFrequencyValue(frecuencia, 'name')}`
          : `${cuotas} cuotas mensuales`
    },

    getGeneratorPdfDomain () {
      return this.generatorPdfDomain
    },

    getMarketPlaceDomain () {
      return this.marketPlaceDomain
    },

    getUniversityDomain () {
      return this.universityDomain
    },

    hexToRgb (hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b
      })

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
      ] : null
    },

    hideAsideNavigationMenu () {
      let documentViewportLandscape = document.documentElement.clientWidth
      let appViewportLandscape = this.getCssVariable('--app-viewport-landscape').replace('px', '')
      this.showAsideNavigationMenu = !(documentViewportLandscape <= appViewportLandscape)
    },

    isUrl (str) {
      var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/
      return regexp.test(str)
    },

    newDate (date) {
      let fecha = date.split('-')
      return new Date(fecha[0], fecha[1] - 1, fecha[2])
    },

    parseVideo (url, autoplay = false) {
      // - Supported YouTube URL formats:
      //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
      //   - http://youtu.be/My2FRPA3Gf8
      //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
      // - Supported Vimeo URL formats:
      //   - http://vimeo.com/25451551
      //   - http://player.vimeo.com/video/25451551
      // - Also supports relative URLs:
      //   - //player.vimeo.com/video/25451551
      var ua = navigator.userAgent
      var nav = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

      let src = false
      url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\S+)?/)
      if (RegExp.$3.indexOf('youtu') > -1) {
        if (nav[1] === 'Chrome' && autoplay) {
          src = '//www.youtube.com/embed/' + RegExp.$6 + '?showinfo=0&rel=0&modestbranding=1&mute=1'
        } else {
          src = '//www.youtube.com/embed/' + RegExp.$6 + '?showinfo=0&rel=0&modestbranding=1'
        }
      } else if (RegExp.$3.indexOf('vimeo') > -1) {
        if (nav[1] === 'Chrome' && autoplay) {
          src = '//player.vimeo.com/video/' + RegExp.$6 + '?sidedock=0&title=0&byline=0&portrait=0&muted=1'
        } else {
          src = '//player.vimeo.com/video/' + RegExp.$6 + '?sidedock=0&title=0&byline=0&portrait=0'
        }
      } else if (url.includes('amazon')) {
        src = url
      }
      return src
    },

    parseScriptTags (script) {
      let exp = /<script[^>]*>(.*?)<\/script[^>]*>/
      let result = exp.exec(script)
      return result.length ? result[0] : false
    },

    pascalCaseToSlug (string) {
      return string.split(/(?=[A-Z])/).join('-').toLowerCase()
    },

    rgbToHex (rgb, alpha = false) {
      rgb = rgb.split('(')[1].split(')')[0].split(',')

      let r = (+rgb[0]).toString(16)
      let g = (+rgb[1]).toString(16)
      let b = (+rgb[2]).toString(16)

      if (r.length === 1) {
        r = '0' + r
      }
      if (g.length === 1) {
        g = '0' + g
      }
      if (b.length === 1) {
        b = '0' + b
      }

      if (alpha) {
        let a = Math.round(+rgb[3] * 255).toString(16)

        if (a.length === 1) {
          a = '0' + a
        }

        return '#' + r + g + b + a
      }

      return '#' + r + g + b
    },

    setCssVariable (variable, newValue) {
      document.documentElement.style.setProperty(variable, newValue)
    },

    showNativePlayer (videoUrl) {
      return videoUrl.includes('amazon')
    },

    stringCapitalized (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    stringToSlug (str) {
      // trim
      str = str.replace(/^\s+|\s+$/g, '')
      str = str.toLowerCase()
      // remove accents, swap ñ for n, etc
      let from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      let to = 'aaaaeeeeiiiioooouuuunc------'
      for (var i = 0; i < from.length; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }
      // remove invalid chars
      str = str.replace(/[^a-z0-9 -]/g, '')
      // collapse whitespace and replace by -
      str = str.replace(/\s+/g, '-')
      // collapse dashes
      str = str.replace(/-+/g, '-')
      return str
    },

    switchAsideNavigationMenu () {
      this.showAsideNavigationMenu = !this.showAsideNavigationMenu
    },

    topPage () {
      // for Safari
      document.body.scrollTop = 0
      // for Chrome, Firefox, IE and Opera
      document.documentElement.scrollTop = 0
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$utils = utils
  }
}
